const axios = require('axios');
import ObjectUtil from './ObjectUtil';
import { stringify } from "qs";

const defaultOpt = {
	loading: true,//是否开启加载框，默认开启
	method: 'post',//请求方式 ,默认post
	appendToken: true,//是否author
	fullscreen: false,//loading加载是否全屏
	errorMsg: true,//是否出现错误提示
};

export async function doAjax(url, param, vm, options) {

	let opt = Object.assign({}, defaultOpt, options);

	let loadingConf = null;
	if (opt.fullscreen) {
		loadingConf = {
			left: '0',
			right: '0px',
			bottom: '0px',
			top: '0'
		};
	}
	let loadingHolder = null;
	try {
		let instance = null;

		if (opt.appendToken === true) {
			let token = await vm.$getToken();
			instance = axios.create({
				headers: {
					"Authorization": token,
					"Content-Type": "application/json;charset=UTF-8"
				}
			})
		} else {
			instance = axios.create();
		}
	
		if(opt.loading){
			loadingHolder = ELEMENT.Loading.service()
		}


		instance.defaults.withCredentials = false;
		var result = null;
		if (opt.method.toLowerCase() == 'get') {
			result = await instance.get(appendQuery(url, param, vm));
		} else if (opt.method.toLowerCase() == 'delete') {
			result = await instance.delete(appendQuery(url, param, vm));
		} else {
			result = await instance[opt.method.toLowerCase()](url, param);
		};
		if(loadingHolder){
			loadingHolder.close();
		}
		return result;
	} catch (e) {
		console.error(e);
		if(loadingHolder){
			loadingHolder.close();
		}
		opt.errorMsg && errorStatusHandle(e, vm);

	}

};

// 针对服务器响应码级别和网络错误的的处理函数
function errorStatusHandle(e, vm) {

	if (!!e.response) {	//响应码错误(非200)
		let res = e.response;
		// console.error('status code:' + res.status);
		if (res.status == "401") {

			vm.$message.error("登录信息失效");
			return;
		}
		//TODO 同时多条错误返回，需要控制自弹出一个错误提示
		vm.$showTip({
			type: "error",
			message: e.message
		});

	} else {	//网络错误
		var reg = /Network\sError/i;
		if (reg.test(e.toString())) {
			vm.$message.error("网络连接错误，无法访问业务服务器");
		}
	};
};


//请求为get,delete的方式时，将参数添加到url上
export function appendQuery(url, param, vm) {
	if (ObjectUtil.isEmptyObject(param)) return url;

	let hasParamReg = /\?(\S+=)/;
	let paramArr = url.match(hasParamReg);
	let paramStr = stringify(param);
	if (paramArr == null) {
		return url + '?' + paramStr;
	} else {
		return url + paramStr;
	};

};